import PropTypes from 'prop-types';
import { Box, Flex } from 'roo-ui/components';
import Icon from 'components/Icon';
import { Label } from '../primitives';

const SummaryItem = ({ icon, label, children }) => {
  return (
    <Flex px={[8, 0]} pt={[0, 3]} pb={[1, 3]} alignItems="flex-start">
      <Icon name={icon} display={['none', 'block']} color="greys.steel" bg="greys.alto" p={1} />
      <Box ml="3" flex="1">
        {!!label && <Label>{label}</Label>}
        {children}
      </Box>
    </Flex>
  );
};

SummaryItem.propTypes = {
  icon: PropTypes.string.isRequired,
  label: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default SummaryItem;
